// Province-level aggregations feeding the Indonesia choropleth (page and report slide).

// Net sentiment per province for one brand, from /api/sentiment/by-region rows. Shared
// with the report builder so the page and the slide use the same numbers.
export const brandProvinceValues = (rows, brand) =>
  Object.values(
    (rows || [])
      .filter((x) => x.entity_name === brand)
      .reduce((acc, x) => {
        const key = x.state || x.region_name;
        const sentiment = String(x.sentiment).toLowerCase();
        acc[key] = acc[key] || { province: key, positive: 0, negative: 0, mixed: 0, count: 0 };
        acc[key].count += Number(x.count || 0);
        if (['positive', 'negative', 'mixed'].includes(sentiment))
          acc[key][sentiment] += Number(x.count || 0);
        return acc;
      }, {}),
  ).map((x) => ({ ...x, value: Math.round((100 * (x.positive - x.negative)) / Math.max(1, x.count)) }));
// Issue mentions per 100 conversations per province, from /api/decision/region-crop cells.
export const fieldProvinceValues = (cells) =>
  Object.values(
    cells.reduce((acc, x) => {
      const key = x.state || x.region_name;
      acc[key] = acc[key] || { province: key, count: 0, issues: 0 };
      acc[key].count += Number(x.conversations || 0);
      acc[key].issues += Number(x.need_signals || 0);
      return acc;
    }, {}),
  ).map((x) => ({ ...x, value: Math.round((100 * x.issues) / Math.max(1, x.count)) }));
